module.exports = __webpack_public_path__ + "static/media/add-square-black.12a5d724.svg";